let smitter = () => {
  let all = {};
  return {
    emit(type, payload) {
      (all[type] || []).map((handler) => handler(payload));
    },
    on(type, handler) {
      all[type] = (all[type] || []).concat(handler);
      let removed = false;
      return () => {
        if (removed)
          return;
        all[type].splice(all[type].indexOf(handler), 1);
        removed = true;
      };
    }
  };
};

export { smitter };
